export default "__VITE_ASSET__66d3ee39__"